import { ReactNode } from 'react'

export const StyledDropzoneContainer = ({
  children
}: {
  children: ReactNode
}) => {
  return <section className='flex flex-col'>{children}</section>
}
